module.exports = __webpack_public_path__ + "static/media/one-laptop.cf6d6667.jpg";